import {Stack, Typography} from "@mui/material";
import {Provider} from "react-redux";
import {MemoryRouter, Switch} from "react-router-dom";
import store from "../redux/Store.js";
import APXBuyMeACupOfTea from "./APXBuyMeACupOfTea.jsx";
import APXDeleteAccount from "./APXDeleteAccount.jsx";
import APXLogout from "./APXLogout.jsx";
import {webappName, webappPaths, webappRoutes} from "./js/AppRoutes.js";
import {useInMemoryPlusStatus} from "./plus/APXPlus.js";
import APXPlusHeaderMenuWithPopover from "./plus/APXPlusHearderMenuWithPopover.jsx";


function TopBar() {
	  
	  const {isPlusUser} = useInMemoryPlusStatus();
	  
	  return (
				 <>
						
						<Stack spacing={2} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
							  
							  <Typography variant={"h4"} color={"primary"} width={"100%"}>{webappName}{isPlusUser && "+"}</Typography>
							  
							  {/*NOT->*/ !isPlusUser ?
										 <>
												<APXBuyMeACupOfTea/>
												<APXLogout/>
												<APXDeleteAccount/>
										 </>
										 :
										 <APXPlusHeaderMenuWithPopover/>
							  }
						</Stack>
				 </>
	  );
}


export default function APXWebApp() {
	  return (
				 <Provider store={store}>
						
						<TopBar/>
						
						<MemoryRouter initialEntries={[webappPaths.root]}>
							  <Switch>
									 {webappRoutes.map((route) => route)}
							  </Switch>
						</MemoryRouter>
				 
				 </Provider>
	  );
}


